<div
  class="check-control"
  (keydown)="handleKeyDown($event)"
  (click)="onClick()"
  tabindex="0"
  role="checkbox"
  [attr.aria-checked]="checked"
  [attr.aria-labelledby]="getId()"
  (focus)="onFocus()"
  (blur)="onBlur()"
  (mousedown)="onMouseDown()"
  #checkboxElement
>
  <i class="material-icons check-mark">done</i>
</div>
<div
  *ngIf="htmlOverride"
  class="check-content"
  [style.font-family]="styleOverrides?.fontFamily"
  [style.font-weight]="styleOverrides?.fontWeight"
  [style.font-size]="styleOverrides?.fontSize"
  (click)="onClick()"
  [attr.id]="getId()"
  #label
  [innerHTML]="htmlOverride"
></div>
<div
  *ngIf="!htmlOverride"
  class="check-content"
  [style.font-family]="styleOverrides?.fontFamily"
  [style.font-weight]="styleOverrides?.fontWeight"
  [style.font-size]="styleOverrides?.fontSize"
  (click)="onClick()"
  [attr.id]="getId()"
  #label
>
  <ng-content></ng-content>
</div>
